<div class="nav-history-controls" #history_controls>
  <button
    mat-icon-button
    type="button"
    id="history-back-button"
    class="small-icon-button"
    aria-label="Atrás"
    matTooltip="Atrás · clic derecho para historial"
    [disabled]="!can_go_back()"
    (click)="goBack()"
    (contextmenu)="openHistoryMenu($event, 'back')"
  >
    <mat-icon>arrow_back</mat-icon>
  </button>

  <button
    mat-icon-button
    type="button"
    id="history-forward-button"
    class="small-icon-button"
    aria-label="Adelante"
    matTooltip="Adelante · clic derecho para historial"
    [disabled]="!can_go_forward()"
    (click)="goForward()"
    (contextmenu)="openHistoryMenu($event, 'forward')"
  >
    <mat-icon>arrow_forward</mat-icon>
  </button>
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="menu_origin() ?? history_controls"
  [cdkConnectedOverlayOpen]="history_menu_open()"
  [cdkConnectedOverlayHasBackdrop]="true"
  cdkConnectedOverlayBackdropClass="history-nav-overlay-backdrop"
  [cdkConnectedOverlayPositions]="menu_positions"
  [cdkConnectedOverlayPush]="true"
  [cdkConnectedOverlayViewportMargin]="8"
  (backdropClick)="closeHistoryMenu()"
  (detach)="closeHistoryMenu()"
>
  <div class="history-menu-panel" role="menu" [attr.aria-label]="history_menu_title()">
    <div class="history-menu-header">
      <div class="history-menu-header-icon-wrap" aria-hidden="true">
        <mat-icon>{{ history_menu_icon() }}</mat-icon>
      </div>
      <div class="history-menu-header-copy">
        <span class="history-menu-header-label">{{ history_menu_title() }}</span>
        <span class="history-menu-header-count">{{ history_menu_entries().length }} páginas</span>
      </div>
    </div>

    <ul class="history-menu-list">
      @for (entry of history_menu_entries(); track entry.index; let step = $index; let first = $first) {
        <li>
          <button
            type="button"
            role="menuitem"
            class="history-menu-item"
            [class.is-nearest]="first"
            (click)="goToHistoryIndex(entry.index)"
          >
            <span class="history-step" aria-hidden="true">{{ step + 1 }}</span>
            <span class="history-entry-text">
              <span class="history-entry-title">{{ entry.title }}</span>
              @if (entry.subtitle) {
                <span class="history-entry-subtitle">{{ entry.subtitle }}</span>
              }
            </span>
            @if (first) {
              <span class="history-entry-badge">{{ history_menu_kind() === 'back' ? 'Anterior' : 'Siguiente' }}</span>
            }
          </button>
        </li>
      }
    </ul>
  </div>
</ng-template>
